// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Description_pageContainer__mBcVB","title":"Description_title__18hRP","description":"Description_description__3X4fp"};